<template>
  <div :class="{ faded: is_loading }" class="boolean_question">
    <div class="relative">
      <div v-if="is_loading" class="loading absolute center"></div>
      <checkbox @input="updateQuestionAnswer" :checked="isChecked">{{question.designator}}</checkbox>
    </div>
  </div>
</template>
<script>
import QuestionsHelper from '@/custom/classes/questions_helper.js'
import Checkbox from '@/components/Checkbox'
export default {
  name: 'boolean-question',
  props: ['question', 'resource_type', 'resource_id', 'resource_data'],
  data () {
    return {
      questions_helper: new QuestionsHelper(),
      answered_option_id: '',
      truthy_value_id: '',
      falsey_value_id: '',
      is_loading: false
    }
  },
  computed: {
    isChecked () {
      return this.answered_option_id == this.truthy_value_id
    }
  },
  mounted () {
    this.initTruthyFalsey()
    this.answered_option_id = this.questions_helper.getAnsweredOptionIdsFromQuestion(this.question)[0]
  },
  methods: {
    initTruthyFalsey () {
      this.truthy_value_id = this.question.options.filter(option => option.text == 'TRUE')[0].id
      this.falsey_value_id = this.question.options.filter(option => option.text == 'FALSE')[0].id
    },
    updateQuestionAnswer (is_checked) {
      this.is_loading = true
      this.$network_utils.postQuestionAnswer({
        question_id: this.question.id,
        current_type: this.resource_type,
        current_resource_id: this.resource_id,
        option_ids: is_checked ? (this.truthy_value_id + '') : (this.falsey_value_id + '')
      }).then(() => {
        if (this.resource_type == 'Position') {
          this.$network_utils.sendPositionUpdateEvent({ position_id: this.resource_id, company_id: this.resource_data.company.resource_id, status: this.resource_data.status })
        }
        this.is_loading = false
      })
    }
  },
  components: {
    Checkbox
  }
}
</script>
